import useHistoricBondCreateBase from "./useHistoricBondCreateBase";
import { GUARDIANSHIP_HISTORIC_CREATE_CONFIG } from "./historicBondCreateConfig";

function useGuardianshipBondCreateHistoric() {
  const {
    isLoading,
    errors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    globalState,
    updateGlobalState,
    handleSubmit,
    handleSupportRequestSubmit,
    setErrors,
  } = useHistoricBondCreateBase(GUARDIANSHIP_HISTORIC_CREATE_CONFIG);

  return {
    isLoading,
    errors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    globalState,
    updateGlobalState,
    handleSubmit,
    handleSupportRequestSubmit,
    setErrors,
  };
}

export default useGuardianshipBondCreateHistoric;
